import * as React from "react";
/* empty css                                                                                               */
import { TitleWithIcon } from "../../../../../../../../components/TitleWithIcon/components/TitleWithIcon/TitleWithIcon.js";
import { LocationInfo } from "../../../../../../../../modules/LocationInfo/layout/modules/LocationInfo/layout/LocationInfo.js";
const PickupLocationInformation = ({
  title,
  location,
  onPickupModalShow,
  isTitleHidden = false
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, !isTitleHidden && /* @__PURE__ */ React.createElement(TitleWithIcon, { icon: "store", label: title }), /* @__PURE__ */ React.createElement(LocationInfo, { location, onEdit: onPickupModalShow }));
export {
  PickupLocationInformation
};
//# sourceMappingURL=PickupLocationInformation.js.map
